<template>
    <v-card>
        <v-card-title class="justify-center align-center" style="position: relative;">
            <v-btn icon style="position: absolute; left: 0; top: 50%; transform: translateY(-50%);" @click="$emit('fechar')">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <span style="width: 100%; text-align: center;">
                <h1 style="margin: 0; font-size: 1.4rem;">CONFIGURAÇÕES SENDZAPI</h1>
            </span>
        </v-card-title>
        <v-divider></v-divider>
        <v-alert v-if="alerta.ativo" :type="alerta.tipo" style="width: 100%;">
            {{ alerta.texto }}
        </v-alert>
        <v-card-text class="d-flex flex-column align-center justify-center text-center" style="min-height: 250px;">
            <template v-if="qrcode">
                <v-img :src="qrcode" max-width="400" class="mx-auto mb-4"></v-img>
                <v-btn color="success" @click="confirmarConexao">Já li o Qrcode</v-btn>
            </template>
            <template v-else-if="conexaoAtiva">
                <h2 class="success--text mb-4">Você já possui uma conexão em um dispositivo</h2>
                <v-btn class="mt-2" color="error" @click="interromperConexao">Interromper conexão</v-btn>
            </template>
            <template v-else>
                <v-progress-circular
                    indeterminate
                    :size="50"
                    color="info"
                    class="my-8"
                ></v-progress-circular>
            </template>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    data: () => ({
        qrcode: undefined,
        conexaoAtiva: false,
        alerta: {
            ativo: false,
            tipo: '',
            texto: ''
        }
    }),
    computed: {
        loading () {
            return this.$store.getters.loading
        }
    },
    beforeMount () {
        this.estabelecerConexao()
    },
    methods: {
        estabelecerConexao () {
            this.qrcode = undefined
            this.$store.dispatch('sendZapi', {
                method: 'GET'
            }).then(json => {
                this.qrcode = json.base64
            })
            .catch(err => {
                if (err.message === 'Conexão já existente') {
                    this.conexaoAtiva = true
                }
            })
        },
        confirmarConexao () {
            this.$store.dispatch('sendZapi', {
                method: 'PUT'
            }).then(() => {
                this.qrcode = undefined
                this.$emit('fechar')
            }).catch(err => {
                this.alerta.ativo = true
                this.alerta.tipo = 'error'
                this.alerta.texto = err.message || 'Erro ao confirmar conexão'
            })
        },
        interromperConexao () {
            this.$store.dispatch('sendZapi', {
                method: 'DELETE'
            }).then(() => {
                this.qrcode = undefined
                this.conexaoAtiva = false
                this.estabelecerConexao()
            }).catch(err => {
                this.alerta.ativo = true
                this.alerta.tipo = 'error'
                this.alerta.texto = err.message || 'Erro ao cancelar conexão'
            })
        }
    }
}
</script>